export const Role = {
    Owner: 1,
    Admin: 2,
    Editor: 3
}

export function hasRole(requiredRoles, userRole) {
    return requiredRoles.includes(userRole);
}